import { render, staticRenderFns } from "./SolicitudReclamoForm.html?vue&type=template&id=6b26dda4&external"
import script from "./SolicitudReclamoForm.vue?vue&type=script&lang=js"
export * from "./SolicitudReclamoForm.vue?vue&type=script&lang=js"
import style0 from "./SolicitudReclamoForm.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports